import api, { ValidateAxiosError } from '@/modules/api.service';
import { Contrib_AreaDto, Contrib_DefensoriaDto, Contrib_ServidorDto, Defensor_DefensorDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { atendimentos_titular_input } from '@/api.types.extra';

export class SolarService {
  async relatorioAtendimentos(parametros: atendimentos_titular_input) {
    try {
      const p = {
        p_area_id: parametros.p_area_id ?? 0,
        p_defensoria_id: parametros.p_defensoria_id ?? 0,
        p_defensor_id: parametros.p_defensor_id ?? 0,
        p_servidor_id: parametros.p_defensoria_id ?? 0,
        p_tipo_atendimento: Number(parametros.p_tipo_atendimento ?? 0),
        p_data_inicial: parametros.p_data_inicial ?? '2000-01-01',
        p_data_final: parametros.p_data_final ?? '2000-01-01',
      };

      const response = await api.get(Endpoints.SOLAR + '/atendimentos', {
        params: p,
        responseType: 'blob',
      });

      return new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
      console.warn('Erro ao baixar o PDF:', error);
    }
  }

  async enumerateDefensorias(): Promise<Contrib_DefensoriaDto[]> {
    try {
      const response = await api.get(Endpoints.SOLAR + '/tabelas/defensoria');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar defensorias.');
    }
  }

  async enumerateDefensores(): Promise<Defensor_DefensorDto[]> {
    try {
      const response = await api.get(Endpoints.SOLAR + '/tabelas/defensor');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar defensores.');
    }
  }

  async enumerateServidores(): Promise<Contrib_ServidorDto[]> {
    try {
      const response = await api.get(Endpoints.SOLAR + '/tabelas/servidor');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar servidores.');
    }
  }

  async enumerateAreas(): Promise<Contrib_AreaDto[]> {
    try {
      const response = await api.get(Endpoints.SOLAR + '/tabelas/area');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar areas.');
    }
  }
}